import { ValidationError } from './api-repository';
import {LabelParameters, LabelStore} from './label-store';
import {action, observable} from 'mobx';
import * as Sentry from '@sentry/react';

export abstract class ViewStore {

    @observable
    state: 'loading' | 'refreshing' | 'error' | 'finished' = 'loading';
    @observable
    errorReason: 'user-deleted' | 'generic' = 'generic';

    constructor(protected labelStore: LabelStore) {}

    @action
    async load(process: () => Promise<void>): Promise<void> {
        this.state = 'loading';
        try {
            await process();
            this.state = 'finished';
        } catch (e: unknown) {
            if ((e as ValidationError).name === 'ForbiddenError' && (e as ValidationError).errorMessageCode === 'user-deleted') {
                this.errorReason = 'user-deleted';
                this.state = 'error';
            } else {
                console.error(e);
                this.state = 'error';
                this.errorReason = 'generic';
                Sentry.captureException(e);
            }
        }
    }

    @action
    async refresh(process: () => Promise<void>): Promise<void> {
        this.state = 'refreshing';
        try {
            await process();
            this.state = 'finished';
        } catch (e: unknown) {
            console.error(e);
            this.state = 'error';
            Sentry.captureException(e);
        }
    }

    label(key: string, parameters: LabelParameters = {}): string {
        return this.labelStore.translate(key, this.labelStore.language, parameters);
    }

}
